import { useQuery } from 'react-query';
import axios from 'axios';

const AVAILABILITY_BASE_URL = 'https://padel-admin-ui-uzh.up.railway.app/api';

const normalizeAvailabilityResponse = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.courts)) return payload.courts;
  if (Array.isArray(payload?.availability)) return payload.availability;

  return [];
};

export default (date, enabled = true) => {
  const data = useQuery(
    ['availableBookings', date],
    async () => {
      const params = new URLSearchParams({ date });
      const response = await axios.get(
        `${AVAILABILITY_BASE_URL}/public/availability?${params.toString()}`
      );

      return normalizeAvailabilityResponse(response.data);
    },
    { enabled: enabled }
  );

  return data;
};
